<template>
  <section class="benefit-cards">
    <h2 class="title-highlight">
      <slot name="title" />
    </h2>
    <div v-if="benefits.description" class="module-description container section-subtitle" v-html="benefits.description" />
    <SliderInfinite class="slider" :offset="0">
      <div
        v-for="(card, id) in benefits.cards" :key="id"
        slot="slide"
        class="card"
        :class="`id-${id}`"
      >
        <div class="image-wrapper">
          <img :src="getImage(card.image)" class="card-image">
        </div>
        <h4 class="card-title">
          {{ card.title }}
        </h4>
        <span class="card-desc">
          {{ card.text }}
        </span>
      </div>
    </SliderInfinite>
    <slot name="footer" />
    <div class="button-holder">
      <button
        v-if="benefits.button" class="btn-primary" :class="buttonClass"
        @click="$emit('subscribe')" v-html="benefits.button"
      />
    </div>
  </section>
</template>

<script>
import SliderInfinite from '@itbpbg/lms-components/src/components/SliderInfinite';

export default {
  components: { SliderInfinite },
  props: {
    benefits: { type: Object, default: () => ({}), required: true },
    buttonClass: { type: String, default: '', required: false },
  },
  methods: {
    getImage(image) {
      return require(`../../assets/images/campaigns/${this.$config.platform}-${image}.webp`);
    },
  },
};
</script>

<style lang="scss" scoped>
.benefit-cards {
  .module-description {
    color: var(--main-light-shade-4);
    text-align: center;
    font-size: 21px;
    line-height: 140%;
  }

  .btn-primary {
    margin-top: var(--spacing-50);
  }

  @include bp($bp-mobile) {
    .module-description {
      display: block;
      font-size: 18px;
      line-height: 150%;
      text-align: center;
      color: var(--main-dark-shade-4);
      padding: 0 var(--spacing-24);
    }
  }

  @include bp($bp-phone) {
    h2 {
      width: 100%;
      font-size: 32px;
      margin-bottom: var(--spacing-16);

      &:before {
        background-position: center -32px;
      }
    }

    .btn-primary {
      margin-top: var(--spacing-60);
    }
  }
}
</style>
